<!-- 大見出し -->
<template>
    <div class="report-head">
        <p v-text="title" />
    </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
    props: {
        title: VueTypes.string.isRequired
    },
}
</script>

<style scoped>
  .report-head {
      background-color: #C5D7EF;
      color: #656665;
      font-weight: bold;
      border-radius: 5px;
      font-size: calc(100vw / 70);
      padding-top: 5px;
      padding-bottom: 5px;
  }
  .report-head > p {
      line-height: calc(100vw / 70);
  }
</style>
